import { Component, OnInit, Inject } from '@angular/core';
import { QuoteService } from '../../quote-service.service';
import { InterpretationService } from '../../interpretation.service';
import { QuoteOverviewModel, Recipient, SendQuoteReportVM } from '../../models/interpretation.model';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs/Observable';
import { AppService } from '../../../../app.service';
import { AddRecipientComponent } from '../add-recipient/add-recipient.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { CryptoService } from '../../../../services/crypto.service';

/**
 * This component should be injected into a modal popup. It is used to
 * allow the user to select a list of email addresses to send the interpretation
 * PDF report to.
 *
 * The list of contacts comes from the contacts setup for the equipment this inspection
 * was for. 
 */
@Component({
  selector: 'send-report-modal',
  templateUrl: './send-report-modal.component.html',
  styleUrls: ['./send-report-modal.component.scss']
})
export class SendReportModalComponent implements OnInit {
  quotes: QuoteOverviewModel[] = [];
  recipients: Recipient[] = [];
  inspectionId: number = -1;
  selectedQuoteId: number = -1;
  selectedRecipientEmails: string[] = [];
  selectedCustomerNames: string[] = [];
  oldUcUri: string = "";
  sendingReport: boolean = false;
  loadingQuotes: boolean = true;
  loadingRecipients: boolean = true;
  includeQuoteReport: boolean = false;
  includeQTemperatureReport: boolean = false;
  selectedTemperatureId: number;
  equipment_id: number = 0;
  InspectorName: string = '';
  constructor(private _quotes: QuoteService,
    private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _dialogRef: MatDialogRef<SendReportModalComponent>,
    @Inject(MAT_DIALOG_DATA) private _data: any,
    private _app: AppService,
    private _dialog: MatDialog,
    private _crypto: CryptoService  ) { }

  ngOnInit() {
    this.getModalData();
    this.loadQuotes();
    this.loadRecipients();
    this.loadOldUcUri();
  }

  /**
   * Closes the dialog. Is called when the user clicks
   * the cancel button. 
   */
  public onCancelClick() {
    console.log(' this.recipients', this.recipients)
    this._dialogRef.close();
  }

  /**
   * Opens the add recipient dialog. If the user enters an email address the
   * dialog will return the email entered and this will append it to the selected
   * recipients list. 
   */
  public onAddRecipientClick() {
    let ref = this._dialog.open(AddRecipientComponent);
    ref.afterClosed().subscribe(r => {
      if (r != null) {
        this.recipients.push(r);
        this.selectedRecipientEmails.push(r.Email);
        this.selectedCustomerNames.push(r.Name);
      }
    });
  }

  /**
   * Called when the user clicks the send button. Will call the server and
   * request the PDF report be sent to the selected email addresses. 
   */
sendReportImmediately: boolean = false;
SendReportImmediately(sendReportImmediately: any) {
switch (sendReportImmediately.checked) {
  case true: {
    this.sendReportImmediately = true;
  }
    break
  case false: {
    this.sendReportImmediately = false;
  }
    break;
}
}
  public onSendClick() {
    this.sendReportImmediately = false; // for send it in Queue
    if (this.sendingReport)
      return;

    if (this.selectedRecipientEmails.length != this.selectedCustomerNames.length) {
      this._notify.error('Error', ' ');
      return;
    }
    this.sendingReport = true;
    this._interp.sendPdfReportWithNewParams(this.selectedQuoteId, this.selectedRecipientEmails, this.oldUcUri, this.includeQuoteReport, this.selectedCustomerNames, false, this.sendReportImmediately)
      .subscribe((r:any) => {
        if (r.Status == 1) {
          this._notify.success(r.Message);
          this.sendingReport = false;
          this._dialogRef.close(true);
        } else {
          this._notify.error('Error', r.Message);
          this.sendingReport = false;
        }
      }, err => {
        this._notify.error('Error', 'Failed to add. Please contact TrackTreads support. ');
        this.sendingReport = false;
      });

      // if(this.includeQuoteReport){
      //   let params = new SendQuoteReportVM();
      //   params.quoteId = this.selectedQuoteId;
      //   params.customernames=this.selectedCustomerNames;
      //   params.emailList=this.selectedRecipientEmails;
      //   params.inspectionId = this.inspectionId
      //   this._interp.SendQuoteReport(params).subscribe(res=>{
      //     if(res==true){
      //       console.log("sent Quote")
      //     }else{
      //       console.log("Failed Quote")
      //     }
      //   })
      // }
  }

  /**
  * Updates the selected recipient email list. Is called when a user checks or unchecks
  * a checkbox associated with an email address. 
  * @param {MatCheckboxChange} event The checkbox clicked event
  * @param {string} email The email address of the recipient
  */
  public recipientClicked(event: MatCheckboxChange, email: string, name: string) {
    switch (event.checked) {
      case true: {
        this.selectedRecipientEmails.push(email);
        this.selectedCustomerNames.push(name);
      }
        break
      case false: {
        this.selectedRecipientEmails = this.selectedRecipientEmails.filter(e => e != email);
        this.selectedCustomerNames = this.selectedCustomerNames.filter(n => n != name);
      }
        break;
    }
  }

  /**
   * Returns a count of the number of recommendations added to the
   * currently selected quote. 
   */
  public get recommendationCount(): number {
    let selectedQuote = this.quotes.find(q => q.QuoteId == this.selectedQuoteId);
    if (selectedQuote == null) return 0;
    return selectedQuote.RecommendationIds.length;
  }

  /**
   * Get the data injected into the component from the interpretation page. 
   */

  private getModalData() {
    this.inspectionId = this._data.inspectionId;
    this.selectedQuoteId = this._data.selectedQuoteId;
    this.selectedTemperatureId = this._data.selectedTemperatureId;
    this.equipment_id = this._data.equipment_id;
    this.InspectorName = this._data.InspectorName

    if (this.selectedTemperatureId > 0) {
      this.includeQTemperatureReport = true;
    } else
      this.includeQTemperatureReport = false;
  }

  /**
   * Gets the old undercarriage application url. We need this to call the
   * generate and email pdf api call. It is way too much work to copy all that logic into
   * the BLL when we want to replace it soon anyway. 
   */
  private loadOldUcUri() {
    this._app.getAppUris().subscribe(r => this.oldUcUri = r.oldUCUri);
  }

  /**
   * Loads the list of quotes from the server. This service should already be
   * initialized with the last inspection id viewed, so that is where the quote
   * id's come from. 
   */
  private loadQuotes() {
    this.quoteApi.subscribe(r => {
      console.log("quoteApi", r)
      this.quotes = r;
      this.loadingQuotes = false;
    }, f => {
      this._notify.error('Error', 'Unable to load a list of quotes. ');
    });
  }

  /**
   * Loads the list of recipients from the server. Adds all the returns recipient emails
   * to the selected recipient email list. 
   */
  // private loadRecipients() {
  //   this.recipientList.subscribe(r => {
  //     this.recipients = r;
  //     this.loadingRecipients = false;

  //     this.recipients.forEach(recipient => {
  //       this.selectedRecipientEmails.push(recipient.Email);
  //       this.selectedCustomerNames.push(recipient.Name);
  //       //AES256
  //       if (recipient?.Email && recipient.Email.length > 0) {
  //         recipient.Email = this._crypto.decrypt(recipient.Email);
  //         }
  //       if (recipient?.Name && recipient.Name.length > 0) {
  //         recipient.Name = this._crypto.decrypt(recipient.Name);
  //         }
  //     });

  //   }, f => {
  //     this._notify.error('Error', 'Unable to load a list of recipients. ');
  //   });
  // }
private loadRecipients() {
  this.recipientList.subscribe(r => {
    this.recipients = r;
    this.loadingRecipients = false;

    this.recipients.forEach(recipient => {

      // decrypt only for display
      recipient.DecryptedEmail = recipient?.Email
        ? this._crypto.decrypt(recipient.Email)
        : '';

      recipient.DecryptedName = recipient?.Name
        ? this._crypto.decrypt(recipient.Name)
        : '';

      // keep encrypted values for backend
      this.selectedRecipientEmails.push(recipient.Email);
      this.selectedCustomerNames.push(recipient.Name);

    });

  }, f => {
    this._notify.error('Error', 'Unable to load a list of recipients.');
  });
}
  /**
   * Get the quotes list as an observable
   */
  private get quoteApi(): Observable<QuoteOverviewModel[]> {
    this._quotes.reloadQuoteOverview(this.inspectionId);
    return this._quotes.getQuoteOverviews();
  }

  /**
   * Get the list of contacts as an observable
   */
  private get recipientList(): Observable<Recipient[]> {
    var res = this._interp.getRecipientList(this.inspectionId, this.equipment_id, this.InspectorName);
    //console.log('res', res)
    
    console.log('res', res);
    return res;
  }

  // Toggle including or excluding the Quote Report in the email.
  private toggleIncludeQuoteReport(e) {
    this.includeQuoteReport = !this.includeQuoteReport;
  }

  private toggleIncludeTemperatureReport(e) {
    this.includeQTemperatureReport = !this.includeQTemperatureReport;
  }
}
